"use client";

import React from "react";
import {useSearchParams} from "next/navigation";
import {LangLink} from "@/components/locales/LangLink";
import type {Locale} from "@/i18n-config";
import {
    isExternalNotificationHref,
    isInternalNotificationHref,
    preserveNotificationCompanyParam,
} from "@/utils/notifications/href";
import {InlineText} from "@/components/content/common/InlineText";

export function NotificationAction({
    locale,
    href,
    label,
    onActivate,
    onInternalNavigate,
    className,
}: {
    locale: Locale;
    href: string;
    label: string;
    onActivate: () => void | Promise<void>;
    onInternalNavigate: () => void;
    className?: string;
}) {
    const searchParams = useSearchParams();

    if (isExternalNotificationHref(href)) {
        return (
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                    void onActivate();
                }}
                className={className}
            >
                <InlineText value={label} />
            </a>
        );
    }

    if (!isInternalNotificationHref(href)) {
        return null;
    }

    const contextualHref = preserveNotificationCompanyParam(
        href,
        searchParams.get("company"),
    );

    return (
        <LangLink
            lang={locale}
            href={contextualHref}
            onClick={() => {
                void onActivate();
                onInternalNavigate();
            }}
            className={className}
        >
            <InlineText value={label} />
        </LangLink>
    );
}
